// Paper Sizes
export const PAPER_4R = {
  width: 900,
  height: 600, // Changed to landscape to match your Tropical image
  dpi: 150,
  printWidth: 1800,
  printHeight: 1200,
  printDpi: 300
};

export const photoboothFrames = [
];

export const get4RPrintLayout = (frame) => {
  return {
    width: PAPER_4R.printWidth,
    height: PAPER_4R.printHeight,
    dpi: PAPER_4R.printDpi,
    photos: frame.photoLayout.map(layout => ({
      x: layout.x * 2,
      y: layout.y * 2,
      width: layout.width * 2,
      height: layout.height * 2
    }))
  };
};
